import { render, staticRenderFns } from "./CoinPerformance.vue?vue&type=template&id=4589aca2&scoped=true&"
import script from "./CoinPerformance.vue?vue&type=script&lang=ts&"
export * from "./CoinPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./CoinPerformance.vue?vue&type=style&index=0&id=4589aca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589aca2",
  null
  
)

export default component.exports